import { render, staticRenderFns } from "./cModalProcInvasivo.vue?vue&type=template&id=4c63570e&scoped=true"
import script from "./cModalProcInvasivo.vue?vue&type=script&lang=js"
export * from "./cModalProcInvasivo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c63570e",
  null
  
)

export default component.exports